import { useMemo } from 'react';

import { useApp } from '../context/app-context';
import { UserRole } from '../types/enums';
import { hasRoles } from '../utils/users-util';

export const useHasPermissions = (roles: UserRole[]) => {
  const { user, userIsFetched } = useApp();
  return useMemo(
    () => userIsFetched && hasRoles(user.roleStrings, roles),
    [roles, user.roleStrings, userIsFetched]
  );
};

export const usePermissions = () => {
  return {
    isAdmin: useHasPermissions([UserRole.Admin, UserRole.SuperAdmin]),
    isEmployee: useHasPermissions([
      UserRole.Admin,
      UserRole.SuperAdmin,
      UserRole.Employee,
      UserRole.Manager,
      UserRole.Owner,
    ]),
    isOwner: useHasPermissions([
      UserRole.Admin,
      UserRole.SuperAdmin,
      UserRole.Owner,
    ]),
    isManager: useHasPermissions([
      UserRole.Admin,
      UserRole.SuperAdmin,
      UserRole.Owner,
      UserRole.Manager,
    ]),
  };
};
